export default {
  gray_color: '#9a9a9a',
  brand_color: '#673AB7'
}
